import React, { useContext } from 'react';
import { buildWordHierarchy } from '../../utils/wordlist/buildWordHierarchy';
import WordlistContext from './_contexts/WordlistContext';
import WordlistRow from './WordlistRow';
import useWordlistWords from './_hooks/useWordlistWords';

export const ESTIMATED_WORD_ROW_HEIGHT = 42;

export default function WordlistHierarchyList() {
  const {
    switched,
    favoriteIds: favorites,
    selectedWord,
    setSelectedWord,
    toggleFavoriteWord,
    module,
  } = useContext(WordlistContext);
  const words = useWordlistWords();

  if (!words || !module) return <div className="wordlist__list bc-shimmer" />;

  const wordHierarchy = buildWordHierarchy(words, module.name);

  return (
    <div className="wordlist__list">
      {Object.values(wordHierarchy).map(header => (
        <React.Fragment key={`header-${header.id}`}>
          <div
            className={`wordlist__header wordlist__header--level-${header.level}`}
            role="heading"
            aria-level={header.level}
            id={`header-${header.id}`}
          >
            {header.title}
            <span className="wordlist__badge wordlist__badge--inverted" role="status">
              {header.amount}
            </span>
          </div>
          {header.attachedWords.length > 0 && (
            <table
              className="wordlist__table"
              style={{
                height: header.attachedWords.length * ESTIMATED_WORD_ROW_HEIGHT,
              }}
              aria-labelledby={`header-${header.id}`}
            >
              <tbody>
                {header.attachedWords.map(word => (
                  <WordlistRow
                    key={`word-${word.id}`}
                    word={word}
                    isFavorite={favorites.includes(word.id)}
                    onFavorite={() => toggleFavoriteWord(word.id)}
                    switched={switched}
                    isActive={selectedWord?.id === word.id}
                    onClick={() => setSelectedWord(word)}
                  />
                ))}
              </tbody>
            </table>
          )}
        </React.Fragment>
      ))}
    </div>
  );
}
